<section class="background-gradient">
  <div class="container p-4">
    <div class="row">
      <div class="col-lg-12">
        <h2 class="text-white text-center p-4">Solutions</h2>
      </div>
    </div>
  </div>
</section>
<section class="solution">
  <div class="container-fluid p-5">
    <div class="row">
      <div class="col-lg-12">
        <ul class="nav nav-pills flex-column flex-sm-row align-items-start" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link link" [ngClass]="{'active': !activeTab || activeTab === 'all'}" data-toggle="tab" role="button" (click)="filterSolutions(null)"
              aria-controls="all" aria-selected="true">All</a>
          </li>
          <li class="nav-item" *ngFor="let group of $groups | async">
            <a class="nav-link link" [ngClass]="{'active': activeTab === group}" data-toggle="tab" role="button" (click)="filterSolutions(group)"
              aria-controls="group" aria-selected="false" id="{{group}}">{{group}}</a>
          </li>
        </ul>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12 p-3" *ngFor="let solution of $solutions | async">
        <div class="card shadow p-2">
          <div class="card-body">
            <img *ngIf="solution.img" src="{{solution.img}}" class="solution-container solution-contents">
            <div class="text-center pt-2">
              <h4 class="solution-name mb-0">{{solution.title}}</h4>
              <h5 class="mb-0" *ngIf="solution.title">{{solution.header}}</h5>
              <h5 *ngIf="solution.vendor" class="mt-2">Solution by: {{solution.vendor}}</h5>
              <a class="card-link text-secondary link" [ngClass]="{'hide': !solution.details}" data-toggle="modal"
                data-target="#details" (click)="selectSolution(solution)">More</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- solution details modal -->
<div class="modal fade" id="details" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header border-bottom-0">
        <button type="button" class="close close-custom" data-dismiss="modal" aria-label="Close">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="col-lg-12 p-2">
            <img *ngIf="selectedSolution?.img" src="{{selectedSolution?.img}}"
              class="solution-container solution-contents">
          </div>
          <div class="col-lg-12 p-1">
            <div class="text-center p-2">
              <h5 class="mb-0 mt-1 font-weight-bold text-left" *ngIf="selectedSolution?.title">{{selectedSolution.header}}</h5>
              <div class="text-left mt-3">
                <ul>
                  <li *ngFor="let bullet of selectedSolution?.details.bullets">
                    <span>{{bullet}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-12 p-3">
            <p class="px-3" style="white-space: pre-line;">{{selectedSolution?.details?.description}}</p>
          </div>
          <div *ngIf="selectedSolution?.vendor" class="col-lg-12">
            <p>Solution by: {{selectedSolution.vendor}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>